import { Box } from '@osmosis/react-ui/components/Box';
import { Dispatch, SetStateAction } from 'react';
import PopupMenuRow from '../../PopupMenuRow';
import { PopupMenuItem } from '../../PopupMenu';

interface QuizSettingsPopupItemsI {
  item: PopupMenuItem;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

/**
 * Component return some buttons for popup.
 */
export const QuizSettingsPopupItems = ({
  item,
  setOpen,
}: QuizSettingsPopupItemsI) => {
  const { onClick, ...rest } = item;

  return (
    <Box>
      <PopupMenuRow
        onClick={() => {
          if (onClick) {
            setOpen(false);
            onClick();
          }
        }}
        item={rest}
        data-testid={`quiz-settings-${item.text}-item`}
      />
    </Box>
  );
};
